import { Navigate, NavLink, Route, Routes } from "react-router";
import { ChatsTab } from "./admin/ChatsTab";
import { UsersTab } from "./admin/UsersTab";

/**
 * Администрирование — только роль admin. Справочники и перевозчики вынесены в /directory (доступны логистам),
 * профиль — в /profile. Ставки с авторами показываются на карточке лота (блок «Все ставки (админ)»).
 * Ещё не сделано: журнал действий, настройки, экспорт Excel, группы рассылки, статистика.
 */
const TABS = [
  { path: "users", label: "Пользователи" },
  { path: "chats", label: "Чаты" },
] as const;

export function AdminPage() {
  return (
    <>
      <div className="page-header">
        <h1>Администрирование</h1>
      </div>
      <nav className="tabs">
        {TABS.map((t) => (
          <NavLink key={t.path} to={`/admin/${t.path}`}>
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Routes>
        <Route index element={<Navigate to="/admin/users" replace />} />
        <Route path="users" element={<UsersTab />} />
        <Route path="chats" element={<ChatsTab />} />
        <Route path="*" element={<Navigate to="/admin/users" replace />} />
      </Routes>
    </>
  );
}
